import { useCallback } from 'react';
import { useReactFlow, ReactFlowJsonObject } from '@xyflow/react';

export const useFlowSave = () => {
  const { toObject, setNodes, setEdges, setViewport } = useReactFlow();

  const saveFlow = useCallback(() => {
    const flow = toObject();
    const jsonString = JSON.stringify(flow, null, 2);
    
    const blob = new Blob([jsonString], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `comfy-layout-${new Date().toISOString().slice(0, 19).replace(/:/g, "-")}.json`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }, [toObject]);

  const loadFlow = useCallback((file: File) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const flow = JSON.parse(e.target?.result as string) as ReactFlowJsonObject;
        if (flow) {
          const { x = 0, y = 0, zoom = 1 } = flow.viewport || {};
          setNodes(flow.nodes || []);
          setEdges(flow.edges || []);
          setViewport({ x, y, zoom });
        }
      } catch (err) {
        console.error("Layout import failed", err);
        alert("Invalid JSON layout file");
      }
    };
    reader.readAsText(file);
  }, [setNodes, setEdges, setViewport]);

  return { saveFlow, loadFlow };
};